import React, { Fragment, useEffect, useMemo, useRef, useState } from "react";
import parse from "html-react-parser";
import { Col, FormGroup, Label } from "reactstrap";
import { Types } from "../../../utils/DynamicForm.config";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import Editor from "ckeditor5-custom-build/build/ckeditor";
import "@ckeditor/ckeditor5-build-classic/build/translations/es";
import { getInputStatus } from "../../../services/commonServices";
import PrintInputError from "../../InputUtils/PrintInputError";
import ckUploader from "../../../services/ckUploader";
import InputDescription from "../../InputUtils/InputDescription";

// ❌ OJO: Eliminado el timeout global compartido

const TypeFormTextareaRich = ({
  label,
  value,
  required,
  errors,
  name,
  onChange,
  options,
  relatedData = {},
  isEditing = true,
  labelColumn = { xs: 6, md: 2 },
  inputColumn = { xs: 6, md: 10 },
  alwaysEditableFields,
  editable,
  custom_tags_plugins,
}) => {
  const [currentValue, setCurrentValue] = useState(value || "");
  const debounceRef = useRef(null);
  const wrapperRef = useRef(null);

  // id/clave única por instancia (usa name si es único en el form)
  const editorId = useMemo(
    () => `ck-${name}-${Math.random().toString(36).slice(2, 8)}`,
    [name],
  );

  const isEditable = Array.isArray(alwaysEditableFields)
    ? alwaysEditableFields.some((item) => item === name) || editable
    : editable;

  // Crea un config por instancia (evita mutaciones compartidas)
  const config = useMemo(() => {
    if ((options && options.custom_tags_plugins) || custom_tags_plugins) {
      return undefined;
    }
    return {
      fontSize: { options: [9, 11, 13, "default", 17, 19, 21, 24, 48] },
      toolbar: {
        items: [
          "Cut",
          "Copy",
          "Paste",
          "PastePlainText",
          "PasteFromWord",
          "|",
          "undo",
          "redo",
          "|",
          "bold",
          "italic",
          "underline",
          "strikethrough",
          "|",
          "FontSize",
          "fontColor",
          "fontBackgroundColor",
          "|",
          "blockQuote",
          "link",
          "mailTo",
          "|",
          "bulletedList",
          "numberedList",
          "|",
          "alignment",
          "|",
          "ImageUpload",
          "mediaEmbed",
          "HtmlEmbed",
          "|",
          "Subtitle",
          "Warning",
          "sourceEditing",
          "maximize",
        ],
      },
      // Si tu plugin Maximize permite configurar contenedor/escopo, hazlo aquí.
      // maximize: { container: `#${editorId}` }
    };
  }, [options, custom_tags_plugins, editorId]);

  // Sincroniza cuando cambia la prop `value` desde fuera (edición inicial, resets, etc.)
  useEffect(() => {
    setCurrentValue(value || "");
  }, [value]);

  // Debounce POR INSTANCIA del onChange hacia el form
  useEffect(() => {
    if (debounceRef.current) clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => {
      if (onChange) {
        onChange({ target: { name, value: currentValue } });
      }
    }, 500);
    return () => {
      if (debounceRef.current) clearTimeout(debounceRef.current);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentValue, name]);

  const handleOnInit = (editor) => {
    if (!editor) return;
    editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
      return new ckUploader(loader);
    };
  };

  const handleChange = (_event, editor) => {
    setCurrentValue(editor.getData());
  };

  return (
    <FormGroup row ref={wrapperRef}>
      <Col {...labelColumn}>
        <Label htmlFor={editorId}>
          {required ? "*" : ""} {label}
        </Label>
      </Col>
      <Col {...inputColumn}>
        {isEditing && isEditable ? (
          <Fragment>
            <div
              id={`${editorId}-wrapper`}
              className={`TextareaRich ${getInputStatus(required, value, errors)} ${relatedData.class || ""}`}
            >
              <CKEditor
                key={editorId} // 🔑 fuerza instancia independiente
                editor={Editor}
                id={editorId} // 🆔 id único para el elemento
                data={currentValue}
                onReady={handleOnInit}
                onChange={handleChange}
                config={config}
              />
            </div>
            <PrintInputError errors={errors} />
            <InputDescription description={relatedData?.description || ""} />
          </Fragment>
        ) : (
          parse(value || "")
        )}
      </Col>
    </FormGroup>
  );
};

TypeFormTextareaRich.propTypes = Types.inputType;
export default TypeFormTextareaRich;
